__turbopack_context__.v({
  "box": "callOutBox-module-scss-module__y7GEpG__box",
});
